<template>
  <v-dialog
    v-model="isDialogVisible"
    persistent
    width="500"
    :z-index="2000"
  >
    <v-card
      v-if="booking"
    >
      <v-card-title class="headline">
        Agregar Nota
      </v-card-title>
      <v-card-text>
        <booking-data
          :booking="booking"
        />
      </v-card-text>
      <v-card-text>
        <notes-textarea
          ref="notesTextarea"
          source="bookings"
          mandatory
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="me-3"
          type="submit"
          @click="OnSubmit()"
        >
          Agregar
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          type="reset"
          @click="isDialogVisible = false"
        >
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref } from '@vue/composition-api'
import BookingData from '@/components/BookingData.vue'
import NotesTextarea from '@/components/controls/NotesTextarea.vue'
import { required } from '@/@core/utils/validation'

export default {
  components: { BookingData, NotesTextarea },
  setup(_, { emit }) {
    const isDialogVisible = ref(false)
    const notesTextarea = ref()
    const booking = ref()

    const ShowDialog = item => {
      if (notesTextarea.value) {
        notesTextarea.value.Clear()
      }
      booking.value = item
      isDialogVisible.value = true
    }

    const OnSubmit = () => {
      if (notesTextarea.value.Validate()) {
        notesTextarea.value.Save({ sourceKey: booking.value.bookingKey })
        isDialogVisible.value = false
        emit('onInsert')
      }
    }

    return {
      isDialogVisible,
      notesTextarea,
      booking,
      OnSubmit,
      ShowDialog,
      validators: { required },
    }
  },
}
</script>
